/* eslint-disable no-undef */
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const swiperContainer = document.querySelector('.swiper');

if (swiperContainer) {
    const mySwiper = new Swiper('.swiper', {
        slidesPerView: 1.5,
        spaceBetween: 10,
        loop: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        allowTouchMove: false,
        speed: 2000,
        breakpoints: {
            1201: {
                slidesPerView: 2,
                spaceBetween: 30,
            }
        }
    });

    window.addEventListener('resize', () => {
        mySwiper.update();
    });
}
